(($)=>{
   $('.home-tiles .tile a.instagram-feed-footer').on('click', function(event){
       event.preventDefault();
       let href = $('#sbi_images a.sbi_photo').first().attr('href');
       if(href && href.indexOf('#') !== 0){
           window.open(href, '_blank');
       }
       return false;
   });

})(jQuery)